import Alpine from 'alpinejs'
 
window.Alpine ?? (window.Alpine = Alpine).start()
